import React, { createRef } from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import SelectDate from '../../component/SelectDate';

import PageBar from '../../component/PageBar';
import { GetList, GetListDownload } from '../batcha/http';
import { GetList as GetListBranch } from '../branch/http';
import { GetList as GetListDriver } from '../driver/http';
import moment from 'moment';
import sample from '../../assets/sample.png';

import ReactToPrint from 'react-to-print';
import PrintSpending from '../../print/spending';
import download from 'downloadjs';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            search: {
                page: 1,
                size: 30,
                sort: '-id',
                status: 'OPENED',
                type: '',
                complete: 'Y',
                branchId: '',
                driverId: '',
                buld_nm: '',
                inspct_dt: [undefined, undefined],
            },
            branch: [],
            driver: [],
            totalPages: 20,
            info: {
                title: '',
                name: '',
                date: '',
                totalNum: 0,
                totalPrice: 0,
                subPrice: 0,
            },
            crawling: false,
        };

        this.printBill = createRef();

        this.role = localStorage.getItem('role', '');

        // const params = sessionStorage.getItem('jobs_search');
        // if (params) {
        //     this.state.search = JSON.parse(params);
        // }
        this.state.search.inspct_dt[0] = moment().format('YYYY-MM-DD 00:00:00');
        this.state.search.inspct_dt[1] = moment().add(7, 'days').format('YYYY-MM-DD 23:59:59');

        GetListBranch(this, { role: 'BRANCH', status: 'OPENED', sort: 'title' }, res => {
            const rows = res.rows.map(x => {
                return { idx: x.id, title: x.title };
            });
            rows.unshift({ idx: '', title: '지사별보기선택' });

            this.setState({
                branch: rows,
            });
        });
        this.reloadDriverList();

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('jobs_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    reloadDriverList = () => {
        const { search } = this.state;
        if (search.branchId) {
            GetListDriver(this, { branchId: search.branchId, status: 'OPENED', sort: 'name' }, res => {
                const rows = res.rows.map(x => {
                    return { idx: x.id, title: x.name };
                });
                rows.unshift({ idx: '', title: '기사별보기선택' });

                this.setState({
                    driver: rows,
                });
            });
        } else {
            GetListDriver(this, { status: 'OPENED', sort: 'name' }, res => {
                const rows = res.rows.map(x => {
                    return { idx: x.id, title: x.name };
                });
                rows.unshift({ idx: '', title: '기사별보기선택' });

                this.setState({
                    driver: rows,
                });
            });
        }
    };

    /**
     * 리스트
     */
    resultList = response => {
        const { search, branch, driver } = this.state;

        const searchBranch = branch.find(x => parseInt(x.idx) === parseInt(search.branchId));
        const searchDriver = driver.find(x => parseInt(x.idx) === parseInt(search.driverId));

        const info = {
            title: searchBranch ? searchBranch.title : '',
            name: searchDriver ? searchDriver.title : '',
            date: moment(search.inspct_dt[0]).format('YYYY년ㅤMM.DD') + 'ㅤ~ㅤ' + moment(search.inspct_dt[1]).format('MM.DD'),
            totalNum: response.range.total,
            totalPrice: response.price,
            subPrice: response.subPrice,
        };

        response.rows.map(x => (x.check = false));
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
            info,
        });
    };

    /**
     * 지사 선택
     * @param {*} array
     * @param {*} value
     */
    selectorBranch = x => {
        const { branch } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    x['branchId'] = e.target.value;
                    this.setState({ data: x }, () => {
                        this.reloadDriverList();
                    });

                    // UpdateAll(this, [{ id: x.id, branchId: x.branchId }]);
                }}
                value={x.branchId}
            >
                {branch.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    /**
     *
     * @param {*} array
     * @param {*} value
     */
    selector = (array, key, value) => {
        const { data } = this.state;

        return (
            <Form.Control
                as="select"
                onChange={e => {
                    data[key] = e.target.value;
                    this.setState({ data });
                }}
                value={value}
            >
                {array.map(x => (
                    <option value={x.idx}>{x.title}</option>
                ))}
            </Form.Control>
        );
    };

    render() {
        const { items, search, branch, driver, info } = this.state;

        const itemsCheck = items.filter(x => x.check);

        const infoView = [];
        if (info.title || info.name) {
            infoView.push(
                <span className="normal">
                    {info.title ? info.title : ''} {info.title && info.name ? 'ㅤ/ㅤ' : ''} {info.name ? info.name + ' 기사님ㅤ' : ''}
                </span>,
            );
        }
        infoView.push(
            <span className="normal">
                {info.date}ㅤ/ㅤ총 &nbsp;{info.totalNum}건
            </span>,
        );
        infoView.push(
            <span className="total">
                합계 = {info.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원 / {info.subPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}{' '}
                원
            </span>,
        );

        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                {this.role === 'ADMIN' && (
                                    <Form.Control
                                        as="select"
                                        onChange={e => {
                                            search.branchId = e.target.value;
                                            search.driverId = '';

                                            this.setState({ search }, () => {
                                                this.reloadDriverList();
                                            });
                                        }}
                                        value={search.branchId}
                                    >
                                        {branch.map(x => (
                                            <option value={x.idx}>{x.title}</option>
                                        ))}
                                    </Form.Control>
                                )}

                                <Form.Control
                                    as="select"
                                    onChange={e => {
                                        search.driverId = e.target.value;
                                        this.setState({ search });
                                    }}
                                    value={search.driverId}
                                >
                                    {driver.map(x => (
                                        <option value={x.idx}>{x.title}</option>
                                    ))}
                                </Form.Control>

                                <div className="gab-w-10"></div>

                                <SelectDate
                                    title=""
                                    value={''}
                                    onChange={(from, to) => {
                                        search.inspct_dt[0] = moment(from, 'YYYY.MM.DD').format('YYYY-MM-DD 00:00:00');
                                        search.inspct_dt[1] = moment(to, 'YYYY.MM.DD').format('YYYY-MM-DD 23:59:59');
                                        this.setState(search);
                                    }}
                                />

                                <div className="gab-w-10"></div>

                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            search.buld_nm = e.target.value;
                                            this.setState({ search });
                                        }}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb"></div>
                        </div>

                        {/* 통계 */}
                        <div className="sum_total_text_box">
                            <div className="in_box">
                                {/* <span className="normal">서울남서울지사 / 오시윤 기사님</span>
                                <span className="normal">2021년 10.08 ~ 11.08 / 총 01건</span>
                                <span className="total">합계 = 3,800,000 원</span> */}
                                {infoView}
                            </div>
                        </div>

                        {/* 지출결의서 */}
                        <Card style={{ display: 'none' }}>
                            {/* <Card> */}
                            <div ref={this.printBill}>
                                {/* {itemsCheck.map(x => (
                                    <PrintSpending data={x} />
                                ))} */}
                                {itemsCheck.length !== 0 && <PrintSpending datas={itemsCheck} />}
                                {itemsCheck.length === 0 && <div style={{ textAlign: 'center', padding: 40 }}>데이터를 선택해주세요.</div>}
                            </div>
                        </Card>

                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">운반통계</Card.Title>
                                <div className="rb">
                                    <button
                                        type="button"
                                        className="btn_01 b_excel"
                                        onClick={e => {
                                            const params = this.state.search;

                                            GetListDownload(this, params, res => {
                                                download(atob(res), 'batchaStats.xlsx', {
                                                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                                });
                                            });
                                        }}
                                    >
                                        엑셀다운로드
                                    </button>
                                    {/* <ReactToPrint
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return (
                                                <button type="button" className="btn_02">
                                                    법인사업자 견적서출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill.current}
                                    />

                                    <ReactToPrint
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return (
                                                <button type="button" className="btn_02">
                                                    일반사업자 견적서출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill2.current}
                                    /> */}

                                    <ReactToPrint
                                        trigger={() => {
                                            return (
                                                <button type="button" className="btn_02">
                                                    지출결의서 출력
                                                </button>
                                            );
                                        }}
                                        content={() => this.printBill.current}
                                    />
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list bg">
                                        <colgroup>
                                            <col />
                                            <col />
                                            <col />
                                            <col width="90" />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            <col />
                                            {/* <col width="100" /> */}
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th
                                                    onClick={e => {
                                                        const { items } = this.state;
                                                        const itemsCheck = items.filter(x => x.check);
                                                        if (itemsCheck.length === items.length) {
                                                            items.map(x => (x.check = false));
                                                        } else {
                                                            items.map(x => (x.check = true));
                                                        }
                                                        this.setState({ items });
                                                    }}
                                                >
                                                    선택
                                                </th>
                                                <th>번호</th>
                                                <th>지역사무소</th>
                                                <th>검사예정일시</th>
                                                <th>건물명</th>
                                                <th>건물주소</th>
                                                {/* <th>접수일자</th> */}
                                                <th>고객안내번호</th>
                                                <th>검사종류</th>
                                                <th>검사대수</th>
                                                {/* <th>검사 신청자ID</th> */}
                                                {/* <th>승강기형식(원장기준)</th> */}
                                                <th>최대시험하중(원장기준)</th>
                                                {/* <th>대표제조업체명(신청서기준)</th> */}
                                                <th>대표유지 관리업체</th>
                                                <th>최대시험하중(신청서기준)</th>
                                                <th>검사자</th>
                                                <th>검사자연락처</th>
                                                <th>분동기사</th>
                                                <th>분동기사연락처</th>
                                                <th>분동차량번호</th>
                                                <th>승강기고유번호</th>
                                                {/* <th>FM여부</th> */}
                                                <th>검사원확인</th>
                                                <th>추가검사원확인</th>
                                                <th>요청수량</th>
                                                <th>공동운반</th>
                                                <th>실운반</th>
                                                <th>작업인원</th>
                                                <th>검사지연</th>
                                                <th>작업내용</th>
                                                <th>정산(단위:원)</th>
                                                {/* <th></th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map(x => {
                                                const br = branch.find(b => b.idx === x.branchId);
                                                return (
                                                    <tr>
                                                        <td className="bgGray">
                                                            <input
                                                                type="checkbox"
                                                                class="saveCheck"
                                                                checked={x.check}
                                                                onChange={e => {
                                                                    x.check = !x.check;
                                                                    this.setState({});
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="bgGray">{x.id}</td>
                                                        {/* <td>{x.inspct_instt_nm}</td> */}
                                                        <td>{br && br.title}</td>
                                                        <td>{moment(x.inspct_dt).format('YYYY-MM-DD HH:mm')}</td>
                                                        <td>{x.buld_nm}</td>
                                                        <td>{x.address}</td>
                                                        {/* <td>{''}</td> */}
                                                        <td>{x.cstmr_guidance_no}</td>
                                                        <td>{x.inspct_kind_nm}</td>
                                                        <td>{x.recptn_cnt}</td>
                                                        {/* <td>{x.reqst_id}</td> */}
                                                        {/* <td>{x.ledg_elvtr_form}</td> */}
                                                        <td>{x.ledg_live_load}</td>
                                                        {/* <td>{x.reqst_mnfctur_cpny_info}</td> */}
                                                        <td>{x.ledg_mnt_cpny_info}</td>
                                                        <td>{x.reqst_live_load}</td>
                                                        <td>{x.manager1 && x.manager1.name}</td>
                                                        <td>{x.manager1 && x.manager1.phone}</td>
                                                        <td>{x.driver && x.driver.name}</td>
                                                        <td>{x.driver && x.driver.phone}</td>
                                                        <td>{x.driver && x.driver.carNumber}</td>
                                                        <td>{x.elevatorId}</td>
                                                        {/* <td>{x.fm > 0 ? 'Y' : 'N'}</td> */}
                                                        <td>
                                                            {/* <img src={sample} style={{ width: 40, height: 20 }} /> */}
                                                            {x.signManager && (
                                                                <a href={x.signManager} target="_blank">
                                                                    <img src={x.signManager} style={{ width: 50, height: 25 }} />
                                                                </a>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {/* <img src={sample} style={{ width: 40, height: 20 }} /> */}

                                                            {x.signAddManager && (
                                                                <a href={x.signAddManager} target="_blank">
                                                                    <img src={x.signAddManager} style={{ width: 50, height: 25 }} />
                                                                </a>
                                                            )}
                                                        </td>
                                                        <td className="bgGray">{x.driverReqNum}</td>
                                                        <td className="bgGray">{x.driverJoinTrans}</td>
                                                        <td className="bgGray">{x.driverTrans}</td>
                                                        <td className="bgGray">{x.driverWorkerNum}</td>
                                                        <td className="bgGray">{x.driverDelay}</td>
                                                        <td className="bgGray">{x.driverComment}</td>
                                                        <td className="bgGray">{x.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
